export const MEMBERS_IN_COLLAPSED_STATE = 3;
